import { validationRules } from 'formsy-react';

export default function isAlphanumericWhitespace(values, value) {
  return validationRules.matchRegexp(values, value, /^[0-9A-Z ]+$/i);
}
